// Single source of truth for "where does a user land right after signing in".
//
// The member area (/home) is disabled — see the removed 'home' route in
// Routes/routes.js and the removed /^\/home$/ pattern in
// server/utils/knownSpaRoutes.js — so regular members now land back on the
// marketing homepage, and only business accounts get routed into the
// dashboard. Previously BusinessPortalView / ConsumerSignInView / LandingPage
// each carried their own slightly different copy of this check.

export const isBusinessUser = (u) =>
  !!u && (u.isAdmin || u.isCreator || u.isObserve || u.isOrganizer);

export const postLoginPath = (u) => (isBusinessUser(u) ? "/admin" : "/");
